import React from 'react'
import Login from '../components/admin/Login'

function AdminLoginPage() {
  return (
    <div>
      <Login/>
    </div>
  )
}

export default AdminLoginPage